import { lazy } from 'react'
export const TipsterAppTourModal =  lazy(() => import('./TipsterAppTour'))
export const TourWelcomeModal =  lazy(() => import('./TourWelcome'))
export const ToolTips =  lazy(() => import('./ToolTip'))
export const ProgressBar =  lazy(() => import('./ProgressBar'))